import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)
var baseRouter = [
  {
    path: '/login',
    component: resolve => require(['../module/auth/login.vue'], resolve),
    name: 'login'
  },
  {
    path: '/forgot-password',
    component: resolve => require(['../module/auth/forgot-password.vue'], resolve),
    name: 'forgotPassword'
  },
  {
    path: '/reset-password',
    component: resolve => require(['../module/auth/reset-password.vue'], resolve),
    name: 'resetPassword'
  },
  {
    path: '/register',
    component: resolve => require(['../module/auth/register.vue'], resolve),
    name: 'register'
  },
  {
    path: '/verify-email',
    component: resolve => require(['../module/auth/verify-email.vue'], resolve),
    name: 'verifyEmail'
  },
  {
    path: '/terms',
    component: resolve => require(['../module/auth/terms.vue'], resolve),
    name: 'terms'
  },
  {
    path: '/account-deleted',
    component: resolve => require(['../module/auth/account-deleted.vue'], resolve),
    name: 'accountDeleted'
  },
  {
    path: '/profile',
    meta: { requiresAuth: true },
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '',
      meta: { requiresAuth: true },
      component: resolve => require(['../module/auth/profile.vue'], resolve),
      name: 'profile'
    }]
  },
  {
    path: '/',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '',
      component: resolve => require(['../module/index.vue'], resolve),
      name: 'index'
    }]
  },
  {
    path: '/tx',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: ':hash',
      props: true,
      component: resolve => require(['../module/tx/detail.vue'], resolve),
      name: 'txHash'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/txList',
      component: resolve => require(['../module/tx/list.vue'], resolve),
      name: 'txList'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/tokens',
      component: resolve => require(['../module/tokens/index.vue'], resolve),
      name: 'tokens'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/tokens/detail/:contractAddress',
      component: resolve => require(['../module/tokens/detail.vue'], resolve),
      name: 'tokensdetail'
    }]
  },
  {
    path: '',
    meta: { requiresAuth: true },
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/tokens/profile-summary/:contractAddress',
      meta: { requiresAuth: true },
      component: resolve => require(['../module/tokens/profile-summary.vue'], resolve),
      name: 'tokenProfileSummary'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/nfts',
      component: resolve => require(['../module/nfts/index.vue'], resolve),
      name: 'nfts'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/nfts/detail/',
      component: resolve => require(['../module/nfts/detail.vue'], resolve),
      name: 'nftsdetail'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/nfts/detail-ztp/:contractAddress',
      component: resolve => require(['../module/nfts/detail-ztp.vue'], resolve),
      name: 'nftsdetail'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/token-id/detail/:tokenId/:contractAddress',
      props: true,
      component: resolve => require(['../module/nfts/detail-tokenid.vue'], resolve),
      name: 'blockDet'
    }]
  },
  {
    path: '/block',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: ':ledgerSeq',
      props: true,
      component: resolve => require(['../module/block/detail.vue'], resolve),
      name: 'blockDet'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/blockList',
      component: resolve => require(['../module/block/list.vue'], resolve),
      name: 'blockList'
    }]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/ztxPrice',
      component: resolve => require(['../module/others/ztxPrice.vue'], resolve),
      name: 'ztxPrice'
    }]
  },
  {
    path: '/account',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [
      {
        path: ':address',
        props: true,
        component: resolve => require(['../module/account/index.vue'], resolve),
        name: 'accountDet'
      },
      {
        path: 'list/:address',
        props: true,
        component: resolve => require(['../module/account/list.vue'], resolve),
        name: 'accountList'
      }
    ]
  },
  {
    path: '',
    component: resolve => require(['../module/App.vue'], resolve),
    children: [{
      path: '/export',
      component: resolve => require(['../module/others/export.vue'], resolve),
      name: 'export'
    }]
  }
]

function join (base, linkgroup) {
  linkgroup.forEach((value) => {
    base.push(value)
  })
}
join(baseRouter, [])

const router = new Router({
  mode: 'history',
  routes: baseRouter
})

// ── JWT helper ───────────────────────────────────────────────────────────────
// Decode the payload of a JWT without verifying the signature.
// Returns null if the token is malformed.
function _decodeJwt (token) {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
  } catch (_) {
    return null
  }
}

// Auth guard — runs BEFORE the component is loaded, preventing any flash.
// Validates that:
//   1. An access token actually exists (not just an explorer_user key that anyone can forge).
//   2. The JWT structure is well-formed (not a spoofed local-storage entry).
//   3. The access token has not expired AND there is no refresh token to fall back on.
//      (If the access token is expired but a refresh token is present we allow the navigation
//       and let the Axios interceptor swap the token on the first API call.)
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const stored = (() => { try { return JSON.parse(localStorage.getItem('explorer_auth')) } catch { return null } })()

    // No tokens at all → login
    if (!stored || !stored.accessToken) {
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }

    const payload = _decodeJwt(stored.accessToken)

    // Malformed / non-JWT value → treat as unauthenticated
    if (!payload) {
      localStorage.removeItem('explorer_auth')
      localStorage.removeItem('explorer_user')
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }

    // Token is expired and there is nothing to refresh with → login
    const nowSec = Date.now() / 1000
    if (payload.exp && nowSec > payload.exp && !stored.refreshToken) {
      localStorage.removeItem('explorer_auth')
      localStorage.removeItem('explorer_user')
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }
  next()
})

export default router
